// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"content-area-placeholder_placeholder__egfC6"};